import { cn } from '@/lib/cn';

/**
 * Yükleme göstergesi (docs/05 §6: "skeleton — kart/tablo şekilli, spinner değil").
 * `aria-hidden`: ekran okuyucular boş kutuları okumasın; yükleme durumu ayrıca duyurulur.
 */
export function Skeleton({ className }: { className?: string }) {
  return (
    <div aria-hidden="true" className={cn('animate-pulse rounded-md bg-slate-200', className)} />
  );
}

/** İlan kartı iskeleti — grid'lerde gerçek kartla aynı yeri kaplar. */
export function ListingCardSkeleton() {
  return (
    <div className="overflow-hidden rounded-card border border-slate-200 bg-surface">
      <Skeleton className="aspect-[3/2] w-full rounded-none" />
      {/* Kartın kendisiyle aynı ölçüler (21.09.2026 kısaltması): etiket, iki satır
          başlık ve tek bilgi satırı. */}
      <div className="space-y-2 px-3 py-2.5">
        <Skeleton className="h-2.5 w-20" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-3/4" />
        <div className="flex items-center justify-between gap-2 pt-0.5">
          <Skeleton className="h-3 w-24" />
          <Skeleton className="h-3 w-16" />
        </div>
      </div>
    </div>
  );
}

export function ListingGridSkeleton({ count = 8 }: { count?: number }) {
  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {Array.from({ length: count }, (_, index) => (
        <ListingCardSkeleton key={index} />
      ))}
    </div>
  );
}

/**
 * Arama sonuçlarının yükleme iskeleti — satır düzeniyle AYNI ölçülerde.
 * Izgara iskeletini satır listesinin üstünde kullanmak, veri gelince düzenin
 * zıplamasına (CLS) yol açıyordu.
 */
export function ListingRowsSkeleton({ count = 6 }: { count?: number }) {
  return (
    <div className="space-y-3">
      {Array.from({ length: count }, (_, index) => (
        <div
          key={index}
          className="flex gap-4 rounded-card border border-slate-200 bg-surface p-3 sm:p-4"
        >
          <Skeleton className="h-24 w-28 shrink-0 rounded-lg sm:h-28 sm:w-36" />
          <div className="flex-1 space-y-2">
            <Skeleton className="h-3 w-24" />
            <Skeleton className="h-4 w-3/4" />
            <Skeleton className="h-3 w-1/2" />
            <Skeleton className="h-3 w-1/3" />
          </div>
          <Skeleton className="h-5 w-24 shrink-0" />
        </div>
      ))}
    </div>
  );
}
